import React from "react";
import styled from "styled-components";
import { StyledSection } from "../../components/common/sections";
import MyContainer from "../../components/ui/myContainer/MyContainer";
import { MainTitle, SubTitle, Text } from "../../components/common/texts";
import { useTranslation } from "react-i18next";
import { FaLinkedinIn } from "react-icons/fa";
import abdaziz from "../../assets/images/who-are-we/abd-aziz.jpg";
import razan from "../../assets/images/who-are-we/razan.jpeg";
import mohammad from "../../assets/images/who-are-we/mohammad.jpeg";

const StyledAbout = styled.div`
  display: flex;
  justify-content: space-between;
  /* flex-direction: column; */
  row-gap: 30px;
  flex-wrap: wrap;
`;

const TeamGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 24px;
  width: 100%;
  margin-top: 18px;
`;

const TeamCard = styled.article`
  min-height: 330px;
  padding: 30px 24px;
  border-radius: 18px;
  background: #fff;
  border: 1px solid rgba(197, 161, 21, 0.18);
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  position: relative;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #c5a115, #f5d76e, #c5a115);
  }

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 14px 30px rgba(197, 161, 21, 0.16);
  }
`;

const TeamPhotoWrap = styled.div`
  width: 128px;
  height: 128px;
  margin-bottom: 18px;
  border-radius: 50%;
  padding: 4px;
  background: linear-gradient(
    135deg,
    ${({ theme }) => theme.colors.primary},
    #f5d76e
  );
  box-shadow: 0 6px 18px rgba(197, 161, 21, 0.22);
`;

const TeamPhoto = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid #fff;
`;

const TeamName = styled.h3`
  font-size: var(--normal-text);
  font-weight: 700;
  color: ${({ theme }) => theme.colors.primary};
  margin-bottom: 12px;
`;

const TeamRole = styled.p`
  font-size: var(--small-text);
  color: #555;
  line-height: 1.7;
  margin-bottom: 22px;
`;

const LinkedInButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-width: 142px;
  padding: 10px 18px;
  border-radius: 999px;
  background: ${({ $disabled }) => ($disabled ? "#e8e8e8" : "#0a66c2")};
  color: ${({ $disabled }) => ($disabled ? "#777" : "#fff")};
  text-decoration: none;
  font-weight: 700;
  pointer-events: ${({ $disabled }) => ($disabled ? "none" : "auto")};
  transition: transform 0.25s ease, box-shadow 0.25s ease;

  &:hover {
    color: #fff;
    transform: translateY(-2px);
    box-shadow: 0 8px 18px rgba(10, 102, 194, 0.24);
  }
`;

const teamLinks = [
  "https://www.linkedin.com/in/abdulaziz-arif-alshammari-28b042193",
  "https://www.linkedin.com/in/razan-alawaji-msc-9a7409161?utm_source=share_via&utm_content=profile&utm_medium=member_ios",
  "https://www.linkedin.com/in/mohammed-almatrafi-210875308?utm_source=share_via&utm_content=profile&utm_medium=member_ios",
];

const teamImages = [abdaziz, razan, mohammad];

const About = () => {
  const { t } = useTranslation("about");
  const teamMembers = [1, 2, 3].map((member, index) => ({
    name: t(`team.member${member}.name`),
    specialist: t(`team.member${member}.specialist`),
    linkedin: teamLinks[index],
    image: teamImages[index],
  }));

  return (
    <MyContainer>
      <StyledSection>
        <StyledAbout>
          <div className="col-md-12">
            <MainTitle $align="initial" className="mb-3">
              {t("title")}
            </MainTitle>
            <Text>{t("text")}</Text>
          </div>

          <div className="col-md-6 p-3">
            <SubTitle>{t("mision.title")}</SubTitle>
            <Text>{t("mision.text")}</Text>
          </div>
          <div className="col-md-6 p-3">
            <SubTitle>{t("vision.title")}</SubTitle>
            <Text>{t("vision.text")}</Text>
          </div>
          <div className="col-md-12">
            <SubTitle $align="center">{t("team.title")}</SubTitle>
            <TeamGrid>
              {teamMembers.map((member) => (
                <TeamCard key={member.name}>
                  <TeamPhotoWrap>
                    <TeamPhoto src={member.image} alt={member.name} />
                  </TeamPhotoWrap>
                  <TeamName>{member.name}</TeamName>
                  <TeamRole>{member.specialist}</TeamRole>
                  <LinkedInButton
                    href={member.linkedin || "#"}
                    target="_blank"
                    rel="noopener noreferrer"
                    $disabled={!member.linkedin}
                  >
                    <FaLinkedinIn />
                    <span>LinkedIn</span>
                  </LinkedInButton>
                </TeamCard>
              ))}
            </TeamGrid>
          </div>
        </StyledAbout>
      </StyledSection>
    </MyContainer>
  );
};

export default About;
